import { render, staticRenderFns } from "./custom-to-do.vue?vue&type=template&id=2ccae09a&scoped=true"
import script from "./custom-to-do.vue?vue&type=script&lang=js"
export * from "./custom-to-do.vue?vue&type=script&lang=js"
import style0 from "./custom-to-do.vue?vue&type=style&index=0&id=2ccae09a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccae09a",
  null
  
)

export default component.exports